<ng-template #hoverReason>
  @for (reason of actionState().message; track $index) {
    <div>
      {{ reason }}
    </div>
  }
</ng-template>
@let actionRequired = actionState().actionRequired;
@let hovered = hoverStatus();
<div class="tw-flex tw-justify-center tw-items-center tw-rounded-full tw-p-2 tw-w-fit dark:tw-text-white"
     [ngClass]=" {
     'tw-bg-sbRed-50 tw-text-sbRed-500 dark:tw-bg-sbRed-800': actionRequired && hovered,
     'tw-bg-sbGreen-50 tw-text-sbGreen-500 dark:tw-bg-sbGreen-800': !actionRequired && hovered,

     }"
     container="body" [ngbTooltip]="hovered? hoverReason : ''" placement="right">
  @if (actionRequired) {
    <sb-icon icon="attention"></sb-icon>
  } @else {
    <sb-icon icon="checked"></sb-icon>
  }
  @if (messagesInline()) {
    <div class="tw-ml-2" style="width: 300px">
      <ng-container [ngTemplateOutlet]="hoverReason"></ng-container>
    </div>
  }
</div>

